import React from 'react';
import AssetStore from '@src/components/asset-store/AssetStore';
import LinkAsset from '../../LinkAsset';
import { AddPOI } from '@src/components/side-bar-menu/poi/AddPOI';
import PortalConfigModal from '@src/components/side-bar-menu/portals/PortralConfigModal';
import UploadAssetModal from '@src/components/side-bar-menu/my-stuff/upload-asset/UploadAssetModal';
import GenerateImageModal from '@src/components/side-bar-menu/my-stuff/generate-image/GenerateImageModal';

export default function EditorModalGroup({
  email,
  isAssetStoreOpen,
  closeAssetStore,
  selectedModel,
  isLinkModalOpen,
  setIsLinkModalOpen,
  isPOIModalOpen,
  setIsPOIModalOpen,
  isPortalModalOpen,
  user,
  setIsPortalModalOpen,
  isMyStuffOpen,
  setIsMyStuffOpen,
  eventSideDrawer,
  isGenerateImageOpen,
  setIsGenerateImageOpen,
}) {
  return (
    <>
      <AssetStore
        userEmail={email}
        isOpen={isAssetStoreOpen}
        closeStore={closeAssetStore}
      />
      <LinkAsset
        id={selectedModel?.props.asset.id ?? ''}
        isOpen={isLinkModalOpen}
        close={() => setIsLinkModalOpen(false)}
      />
      <AddPOI
        selectedModel={selectedModel}
        open={isPOIModalOpen}
        setOpen={setIsPOIModalOpen}
        key={'add-poi'}
      />
      <PortalConfigModal
        id={selectedModel?.props.asset.id ?? ''}
        isOpen={isPortalModalOpen}
        userId={user.id}
        close={() => setIsPortalModalOpen(false)}
      />
      <UploadAssetModal
        userEmail={email}
        isVisible={isMyStuffOpen}
        setIsVisible={setIsMyStuffOpen}
        callback={eventSideDrawer}
      />
      <GenerateImageModal
        userEmail={email}
        isVisible={isGenerateImageOpen}
        setIsVisible={setIsGenerateImageOpen}
        callback={eventSideDrawer}
      />
    </>
  );
}
